import {
  Routes,
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import {JhiResolvePagingParams} from 'ng-jhipster';
import {UserRouteAccessService} from '@app/core';
import {ThuHoachComponent} from '@entities/thu-hoach/thu-hoach/thu-hoach.component';
import {ChiTietThuHoachComponent} from '@entities/thu-hoach/chi-tiet-thu-hoach/chi-tiet-thu-hoach.component';
import {Injectable} from '@angular/core';
import {ThuHoachService} from '@entities/thu-hoach/thu-hoach.service';
import {IThuHoach, ThuHoach} from '@entities/thu-hoach/thu-hoach.model';
import {map} from 'rxjs/operators';
import {HttpResponse} from '@angular/common/http';
import {of} from 'rxjs';

@Injectable({providedIn: 'root'})
export class ThuHoachManagementResolve implements Resolve<IThuHoach> {
  constructor(private service: ThuHoachService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const id = route.params['thuHoach'] ? route.params['thuHoach'] : null;
    if (id) {
      return this.service
        .find(id)
        .pipe(map((thuHoach: HttpResponse<IThuHoach>) => thuHoach.body));
    }
    return of(new ThuHoach());
  }
}

export const thuHoachRoute: Routes = [
  {
    path: 'danh-sach-thu-hoach',
    component: ThuHoachComponent,
    resolve: {
      pagingParams: JhiResolvePagingParams,
    },
    data: {
      authorities: ['can_read_harvests'],
      pageTitle: 'Danh sách thu hoạch',
    },
    canActivate: [UserRouteAccessService],
  },
  {
    path: 'chi-tiet-thu-hoach/:id',
    component: ChiTietThuHoachComponent,
    resolve: {},
    data: {
      authorities: ['can_detail_harvests'],
      pageTitle: 'Chi tiết thu hoạch',
    },
    canActivate: [UserRouteAccessService],
  },
];
